import React, { Component } from "react";
import { serviceBureauService } from "../../services/otodisApi/ServiceBureauService";
import { Select } from "antd";

class ServicebureauSelect extends Component<any, any> {
  private readonly initState!: any;

  constructor(props: any) {
    super(props);

    this.initState = {
      dealerCode: "",
      dataSupplier: [],
      selectSupplierValue: null,
    };
    this.state = { ...this.initState };
  }

  fetchSupplierData = (dealerCode: any) => {
    // FETCH API
    try {
      // API LAMA
      //   bureauApiService.getBureau({}).then((dataFetchSupplier) => {
      //     const dataForState: any = dataFetchSupplier.data.success.data.map((model: { code: string; legal_name: string }) => ({
      //       value: model.code,
      //       name: model.legal_name,
      //     }));
      //     this.setState({
      //       dealerCode: dealerCode,
      //       dataSupplier: dataForState,
      //       selectSupplierValue: null,
      //     });
      //   });
      // END API LAMA

      serviceBureauService.GetServiceBureau({}).then((dataFetchSupplier) => {
        const dataForState: any = dataFetchSupplier.data.data.map((model: { service_bureau_code: string; service_bureau_name: string }) => ({
          value: model.service_bureau_code,
          name: model.service_bureau_name,
        }));
        this.setState({
          dealerCode: dealerCode,
          dataSupplier: dataForState,
          selectSupplierValue: null,
        });
      });
    } catch (e) {
      this.setState({
        dealerCode: dealerCode,
        dataSupplier: [],
        selectSupplierValue: null,
      });
    }

    this.setState({
      dealerCode: dealerCode,
      dataSupplier: [{ value: dealerCode, name: dealerCode }],
      selectSupplierValue: null,
    });
  };

  onChange = (value: any, option: any) => {
    this.setState({
      selectSupplierValue: value,
    });

    this.props.onSupplierChangeProps(option);
  };

  onValueChange = (value: any) => {
    this.setState({
      selectSupplierValue: value,
    });
  };

  async componentDidMount() {
    await this.promisedSetState({
      dealerCode: this.props.dealerCode,
    });
    this.fetchSupplierData(this.props.dealerCode);
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    if (this.props.dealerCode !== prevProps.dealerCode) {
      this.fetchSupplierData(this.props.dealerCode);
    }

    if (this.props.value !== prevProps.value) {
      this.onValueChange(this.props.value);
    }
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <Select
        showSearch
        placeholder="Pilih Biro Jasa"
        optionFilterProp="children"
        onChange={this.onChange}
        filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        value={this.state.selectSupplierValue}
      >
        {this.state.dataSupplier.map((item: any, i: number) => (
          <Select.Option key={item?.value} value={item?.value}>
            {item?.name}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default ServicebureauSelect;
